import { render } from "./Vasos.vue?vue&type=template&id=3ba09ac2&scoped=true"
import script from "./Vasos.vue?vue&type=script&lang=js"
export * from "./Vasos.vue?vue&type=script&lang=js"

import "./Vasos.vue?vue&type=style&index=0&id=3ba09ac2&scoped=true&lang=css"

import exportComponent from "/usr/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba09ac2"]])

export default __exports__